import { cn } from "@/lib/utils";

type AedSymbolProps = {
  className?: string;
  label?: string;
};

export function AedSymbol({ className, label = "AED" }: AedSymbolProps) {
  return (
    <>
      <span className="sr-only">{label}</span>
      <span
        aria-hidden="true"
        className={cn(
          "aed-symbol inline-block shrink-0 align-[-0.08em] bg-current",
          className
        )}
      />
    </>
  );
}
